// /**
//  * Warehouses - list
//  */

// React
import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';
import HeaderBuilder from '../../../utils/headerBuilder';
// UI
import theme from '../../../theme';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Select,
  Checkbox,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Toolbar,
  Tooltip,
  Typography,
  lighten,
  Divider,
  FormLabel,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiPencilOutline,
  mdiChevronDown,
  mdiFileDocumentOutline,
  mdiChevronUp,
  mdiAccountPlus,
  mdiPackageDown,
  mdiPlaylistCheck,
  mdiFileTree,
} from '@mdi/js';
import clsx from 'clsx';

// Helper
import {translate} from '../../../utils/helpers';

//Component
import jMoment from 'moment-jalaali';

// Type
import {Parcels} from '../interfaces';
import {
  rulesAdminChangeParcelStatus,
  rulesParcelStatus,
} from '../../../utils/rulesParcelStatus';
import AuthContext from '../../../authContext';
import Can from '../../../components/Can';
import List from './usersList';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import handleError from '../../../utils/handleError';

type Data = Parcels;
type Props = {
  data: any;
  handleOpenConfirmDisable: (id: number) => void;
  handleOpenConfirmActive: (id: number) => void;
  handleOpen: (id: number, type: string) => void;
  changeStatus: any;
};

type Ord = 'asc' | 'desc';

interface HeadCell {
  // id: keyof Data;
  id: any;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
    },
    body: {
      fontSize: 14,
      whiteSpace: 'nowrap',
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: {[key in Key]: number | string},
  b: {[key in Key]: number | string}
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const headCells: HeadCell[] = [
  {
    id: 'sourceWarehouseName',
    label: 'مبدا',
  },
  {
    id: 'id',
    label: 'شناسه محموله',
  },
  {
    id: 'shippingDate',
    label: 'تاریخ ارسال',
  },
  {
    id: 'deliveryDate',
    label: 'تاریخ تحویل',
  },
  {
    id: 'itemsCount',
    label: 'تعداد تنوع',
  },
  {
    id: 'inventoryItemsCount',
    label: 'تعداد آیتم',
  },
  {
    id: 'status',
    label: 'وضعیت',
  },
];

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
    },
    highlight:
      theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    title: {
      // flex: '1 1 100%',
    },
  })
);

const IconSort = (order: Ord) => {
  return (
    <Icon path={order === 'asc' ? mdiChevronDown : mdiChevronUp} size={1} />
  );
};

const EnhancedTableToolbar = (props: any) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const {numSelected, selected, data} = props;

  const handleClickChangeStatus = () => {
    const selectedData = data.filter(
      (item: any) => selected.indexOf(item.id) > -1
    );

    if (!checkStatus(selectedData)) {
      setOpenAlertWarning(true);
    } else {
      props.setOpenChangeStatus(true);
    }
  };

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status === 'SUBMITTED' || item?.status === 'ASSIGNED') {
        return item;
      }
      return (sameStatus = false);
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              <span style={{marginLeft: '10px'}}>{numSelected}</span>
              <span>{'انتخاب'}</span>
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
          {numSelected > 0 ? (
            <Grid container spacing={2} justify="flex-end">
              <Tooltip style={{marginLeft: '10px'}} title="تخصیص اپراتور">
                <Button
                  size="small"
                  variant="contained"
                  onClick={handleClickChangeStatus}
                  color="secondary"
                >
                  تخصیص اپراتور
                </Button>
              </Tooltip>
            </Grid>
          ) : (
            <></>
            // <Tooltip title="Filter list">
            //   <IconButton aria-label="filter list">
            //     FilterIcon
            //   </IconButton>
            // </Tooltip>
          )}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت محموله وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت محموله آیتم‌های انتخاب شده اشتباه است
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default function EnhancedTable(props: Props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<any>('id');
  const [dense] = React.useState(false);
  const authContext = useContext(AuthContext);
  const [selected, setSelected] = React.useState([]);
  const [openChangeStatus, setOpenChangeStatus] = React.useState(false);
  const [selectedOperator, setSelectedOperator] = useState(0);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.data.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleSelectOperator = (event: {target: HTMLInputElement}) => {
    const {target} = event;
    setSelectedOperator(+target.value);
  };

  const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const changeStatusOrder = async () => {
    const payload = {
      body: selected,
      id: selectedOperator,
      callback: props.callback,
    };
    try {
      const callback = await parcelsRepository.updateGroupParcelStatuses({
        payload,
      });
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const isSelected = (id: string) => selected.indexOf(id) !== -1;
  return (
    <div className={classes.root}>
      <EnhancedTableToolbar
        numSelected={selected.length}
        setOpenChangeStatus={setOpenChangeStatus}
        selected={selected}
        data={props.data}
      />
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <HeaderBuilder
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            numSelected={selected.length}
            rowCount={props.data.length}
            onSelectAllClick={handleSelectAllClick}
            filterVal={props.filterVal}
            onFilterValue={(filtervalues: any) => {
              props.onFilterValue(filtervalues);
            }}
            head={props.head}
            removeFilterHandler={props.removeFilterHandler}
            haveAction={true}
            filterLabelTranslator={props.filterLabelTranslator}
            checkbox={true}
          />
          <TableBody>
            {stableSort(props.data, getComparator(order, orderBy))
              .slice()
              .map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                let color = '';
                let backgroundColor = '';

                switch (true) {
                  case row.status === 'UNLOADING' ||
                    row.status === 'UNLOADED' ||
                    row.status === 'REGISTERED':
                    backgroundColor = '#d1e8fa';
                    color = '#283c74';
                    break;
                  case row.status === 'CANCELLED' || row.status === 'RETURNING':
                    backgroundColor = '#fdd1cc';
                    color = '#611a15';
                    break;
                  case row.status === 'LOCATED' || row.status === 'DELIVERED':
                    backgroundColor = '#d7fcd7';
                    color = '#1e4659';
                    break;
                  case row.status === 'CONFLICTED' || row.status === 'ASSIGNED':
                    backgroundColor = '#ffebcf';
                    color = '#663c40';
                    break;
                  case row.status === 'SHIPPED' || row.status === 'SUBMITTED':
                    backgroundColor = 'white';
                    color = 'black';
                }

                return (
                  <TableRow
                    style={{backgroundColor: backgroundColor}}
                    key={index}
                  >
                    <TableCell padding="checkbox">
                      <Can
                        role={authContext.user.role}
                        perform="orders:changeOrderStatus"
                        yes={() => (
                          <Checkbox
                            key={index}
                            onClick={event => handleClick(event, row.id)}
                            checked={isSelected(row.id)}
                            inputProps={{'aria-labelledby': labelId}}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell style={{color: color}} align="center">
                      {row.sourceWarehouseName}
                      {row.sellerName && `(${row.sellerName})`}
                    </TableCell>
                    <TableCell
                      style={{color: color}}
                      component="th"
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.id}
                    </TableCell>
                    <TableCell
                      style={{color: color}}
                      component="th"
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {translate(row.inboundType, 'parcel')}
                    </TableCell>
                    <TableCell style={{color: color}} align="center">
                      <span>
                        {jMoment(row.deliveryDate, 'YYYY/M/D')
                          .locale('fa')
                          .format('jYY/jMM/jDD')}
                      </span>
                    </TableCell>
                    <TableCell style={{color: color}} align="center">
                      <span>
                        {jMoment(row.deliveryStartTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                        {` - `}
                        {jMoment(row.deliveryEndTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                      </span>
                    </TableCell>
                    <TableCell style={{color: color}} align="center">
                      {row.itemsCount}
                    </TableCell>
                    <TableCell style={{color: color}} align="center">
                      {row.inventoryItemsCount}
                    </TableCell>
                    <TableCell style={{color: color}} align="center">
                      <FormControl style={{width: '100%'}}>
                        <Icon
                          path={mdiPencilOutline}
                          size={1}
                          className={classes.changStatusIcon}
                        />
                        <Select
                          style={{color: color}}
                          className={classes.changStatusBox}
                          fullWidth
                          name={`status${index}`}
                          multiple
                          disabled={
                            rulesAdminChangeParcelStatus[
                              authContext.user.role
                            ].indexOf(row.status) === -1
                          }
                          id={row.id}
                          value={[{}]}
                          IconComponent={() => null}
                          renderValue={() => (
                            <span className={classes.renderValue}>
                              {translate(row.status, 'parcel')}
                            </span>
                          )}
                        >
                          <RadioGroup
                            className={classes.radioGroup}
                            aria-label={`status${index}`}
                            name={`status${index}`}
                            value={'item'}
                            onChange={(
                              e: React.ChangeEvent<{value: unknown}>
                            ) =>
                              props.changeStatus({
                                id: row.id,
                                body: `${e.target.value}`,
                              })
                            }
                          >
                            {rulesParcelStatus[row.status]?.map(
                              (item: any, index: number) => (
                                <FormControlLabel
                                  className={classes.radioGroupItem}
                                  key={index}
                                  checked={row.status === item}
                                  value={item}
                                  control={<Radio />}
                                  label={translate(item, 'parcel')}
                                />
                              )
                            )}
                          </RadioGroup>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      {row.status === 'ASSIGNED' ? (
                        <Link to={`/parcel/${row.id}/unload-inventory-items`}>
                          <IconButton size="small" title="تخلیه محموله">
                            <Icon
                              color={theme.palette.orange.main}
                              path={mdiPackageDown}
                              size={1}
                            />
                          </IconButton>
                        </Link>
                      ) : null}
                      {row.status === 'UNLOADED' ? (
                        <Link to={`/parcel/${row.id}/inventory-items`}>
                          <IconButton size="small" title="تطبیق محموله">
                            <Icon
                              color={theme.palette.blue.main}
                              path={mdiPlaylistCheck}
                              size={1}
                            />
                          </IconButton>
                        </Link>
                      ) : null}
                      {row.status === 'REGISTERED' ? (
                        <Link to={`/parcel/${row.id}/locate-inventory-items`}>
                          <IconButton size="small" title="جایگذاری محموله">
                            <Icon color="purple" path={mdiFileTree} size={1} />
                          </IconButton>
                        </Link>
                      ) : null}
                      <Link to={`/parcels/details/${row.id}`}>
                        <IconButton
                          aria-label="details"
                          size="small"
                          title="جزئیات محموله"
                          data-cy="details"
                        >
                          <Icon
                            path={mdiFileDocumentOutline}
                            size={1}
                            color={theme.palette.green.main}
                          />
                        </IconButton>
                      </Link>
                      {(row.status === 'SUBMITTED' ||
                        row.status === 'ASSIGNED') && (
                        <Link
                          to={`/parcels-operators/${row.id}/warehouse/${row.destinationId}`}
                        >
                          <IconButton
                            aria-label="details"
                            size="small"
                            title="تخصیص محموله"
                            data-cy="details"
                          >
                            <Icon
                              path={mdiAccountPlus}
                              size={1}
                              color={theme.palette.green.main}
                            />
                          </IconButton>
                        </Link>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        fullWidth
        open={openChangeStatus}
        onClose={() => setOpenChangeStatus(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>{'تغییر وضعیت سفارش به تخصیص داده شده'}</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              {'اپراتور مورد نظر را انتخاب کنید'}
            </FormLabel>
            <Grid
              container
              xs={12}
              style={{marginTop: '20px', marginRight: 0, marginLeft: 0}}
            >
              <List
                onSelectOperator={handleSelectOperator}
                selectedOperator={selectedOperator}
                data={props.users}
              />
            </Grid>
          </FormControl>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenChangeStatus(false)}
            variant="outlined"
            color="primary"
          >
            {'انصراف'}
          </Button>
          <Button
            onClick={changeStatusOrder}
            color="primary"
            variant="contained"
            disabled={!selectedOperator}
          >
            {'تخصیص اپراتور'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
